import { render, staticRenderFns } from "./ModalUnsavedChanges.vue?vue&type=template&id=c2207bfe&scoped=true&"
import script from "./ModalUnsavedChanges.vue?vue&type=script&lang=js&"
export * from "./ModalUnsavedChanges.vue?vue&type=script&lang=js&"
import style0 from "./ModalUnsavedChanges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2207bfe",
  null
  
)

export default component.exports